/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core'
import { TranslateLoader } from '@ngx-translate/core'
import { Observable, catchError, forkJoin, from, map, switchMap } from 'rxjs'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { TranslationService } from '../shared/services/translation/translation.service'
import { environment } from '../..//environments/environment'

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
  private http = inject(HttpClient)
  private translationService = inject(TranslationService)
  headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*' })
  getTranslation(lang: string): Observable<any> {
    const localTranslations = this.http.get<Record<string, unknown>>(`./assets/locales/${lang}.json`)

    if (environment.envName === 'local') {
      return localTranslations
    }
    return from(this.translationService.getLanguage(lang)).pipe(
      switchMap((language) => {
        const remoteTranslations = this.http.post<Record<string, unknown>>(
          `${environment.translationsUrl}/select`,
          {
            language: language?.code,
          },
          { headers: this.headers, withCredentials: false },
        )

        return forkJoin([localTranslations, remoteTranslations]).pipe(
          map(([local, remote]) => this.mergeTranslations(local, remote)),
        )
      }),
      catchError((error) => {
        console.error(error)
        return localTranslations
      }),
    )
  }

  private mergeTranslations(local: Record<string, unknown>, remote: Record<string, unknown>): Record<string, unknown> {
    const merged: Record<string, unknown> = { ...local }

    for (const [key, value] of Object.entries(remote)) {
      if (this.isPlainObject(value) && this.isPlainObject(merged[key])) {
        merged[key] = this.mergeTranslations(merged[key], value)
      } else {
        merged[key] = value
      }
    }

    return merged
  }

  private isPlainObject(value: unknown): value is Record<string, unknown> {
    return !!value && typeof value === 'object' && !Array.isArray(value)
  }
}
